<template>
    <div id="newyear">
        <div class="box">
            <div class="box1">
                <div class="price" style="float:left;" @click="active = 69;show=1">
                    <img src="http://static.yuread.cn/quick/y8.png" alt="">
                    <p>限一次</p>
                </div>
                <div class="price" style="float:right;" @click="active = 70; show=1">
                    <img src="http://static.yuread.cn/quick/y7.png" alt="">
                    <p>限两次</p>

                </div>

                <div class="price1" style="float:left;" @click="active = 71;show=1">
                    <img src="http://static.yuread.cn/quick/y6.png" alt="">
                    <p>限三次</p>
                </div>

            </div>
        </div>

        <div class="tip">

            <p>书币属于虚拟商品，一经购买不得退换;</p>
            <p>活动最终解释权归网站所有.</p>
        </div>

        <div class="type" v-if="show" @click="show=false">
            <ul>
                <li class="wechat" :class="{active:type == 6}" @click="setType(6)">
                    <img src="http://static.yuread.cn/quick/wechat1.png" alt=""> 微信充值
                </li>
                <li class="zfb" :class="{active:type == 7}" @click="setType(7)">
                    <img src="http://static.yuread.cn/quick/zfb1.png" alt=""> 支付宝
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Newyear",
        data(){
            return {
                active : 69,
                type : 6,
                show : false,
            }
        },
        methods : {
            setType(type){
                this.type = type;
                system.postMessage(JSON.stringify({
                    active : this.active,
                    type : this.type
                }))
            }
        },
    }
</script>

<style lang="less">
    #newyear{padding:750px 40px 40px 40px;min-height:100%;background-color:#e2233e;background-image: url("http://static.yuread.cn/quick/y2.png");background-size:100% ;background-repeat:no-repeat;overflow: auto;
        .box{padding:12px 10px;width: 658px;height: 616px;margin:0 auto;background-image: url("http://static.yuread.cn/quick/y3.png");background-size: 100% auto;background-repeat:no-repeat;
            .box1{background:#fdf1ca; width: 100%;height:100%;padding: 38px 26px;
                .price{width: 282px;height: 250px;
                    img{width: 100%;}
                    p{width: 100%;text-align: center;color: #824624;}
                }

                .price1{width: 100%;margin-top:20px;
                    img{width: 100%;}
                    p{width: 100%;text-align: center;color: #824624;}
                }
            }
        }
        .tip{margin-top: 76px;
            p{text-align: center;color: #fff;font-size: 24px;}
        }

        .type{
            background-color: rgba(0,0,0,.3);position: fixed;top:0;left:0;right:0;bottom:0;
            ul{ position:absolute;bottom:0;width: 100%;background-color: #fff;display: flex;justify-content: space-between;padding: 102px 40px 68px;border-radius: 58px 58px 0 0;
                li{width: 308px;height:86px;text-align: center;border-radius: 43px;color: #fff;font-size: 32px;line-height: 86px;}
                .wechat{background-color: #32BE1B;}
                .zfb{background-color: #1296db;}
                img{width: 34px;height:34px;position: relative;top:5px;}
            }
        }
    }
</style>
